var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import Styles from './my-wallet-overview-styles.scss';
import TotalSavings from '@/presentation/pages/my-wallet-savings/components/total-savings/total-savings';
import CheckingAccountOverview from '../my-wallet/checking-account/overview/checking-account-overview';
import { ButtonKVBase, CircleLoader, CreditCardScore, DailyEarnings, IconButton, LifetimeEarnings } from '@/presentation/components';
import { IconDollar, IconReceiptItem, IconTransferFunds, MoreInfoIcon } from '@/presentation/components/icons';
import TransferFundsModalWrapper from '../transfer-funds-modal/transfer-funds-modal';
import useMyWalletOverview from './use-my-wallet-overview';
import CreditCardComponent from '../my-wallet/credit-card/components/credit-card-component/credit-card-component';
import useFakeCreditCard from '@/presentation/hooks/use-fake-credit-card';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { useNavigate } from 'react-router';
import classNames from 'classnames';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
import { formatAccountBalance, formatStringAccountBalance } from '@/presentation/utils/money-utils';
import CreditScoreText from '@/presentation/components/credit-card-score/credit-score-text';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
const MyWalletOverview = ({ validationTransferFunds, manageVirtualTransactions, manageVirtualAccounts, validationModalUpdateSaving, manageUser, manageThirdParty }) => {
    var _a;
    const { dates, isLoading, tableValues, openModalFunds, setOpenModalFunds, showCreditScore, setShowCreditScore, totalEarned, cashoutResponse, getStudentCashout } = useMyWalletOverview({ manageVirtualTransactions, manageVirtualAccounts, manageUser });
    const { user } = useUserSesssion();
    const { cardNumber, cvv2, expiry } = useFakeCreditCard();
    const navigate = useNavigate();
    const { creditCardAccount } = useStudentAccounts(false);
    const [paying, setPaying] = useState(false);
    const calculateAvailableCredit = (creditCardAccount) => {
        const availableCredit = Number(creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.creditLimit) - Number(creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.balance);
        if (isNaN(availableCredit))
            return 0;
        return availableCredit;
    };
    const { showCustomError, showCustomSuccess } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    const handleOnCashout = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c, _d;
        try {
            setPaying(true);
            const response = yield manageThirdParty.studentCashout();
            if (response === null || response === void 0 ? void 0 : response.status) {
                const id = (_d = (_c = (_b = response === null || response === void 0 ? void 0 : response.studentCashoutSaved) === null || _b === void 0 ? void 0 : _b.responseData) === null || _c === void 0 ? void 0 : _c.batch_header) === null || _d === void 0 ? void 0 : _d.payout_batch_id;
                if (id) {
                    yield getStudentCashout();
                    showCustomSuccess('Success!', `You have successfully cashed out. Payout id: ${id}`);
                }
            }
            else {
                showCustomError('Oops!', `Error trying to cashout: ${response === null || response === void 0 ? void 0 : response.message}`);
            }
        }
        catch (error) {
            console.log(error);
            showCustomError('Oops!', 'Error trying to cashout');
        }
        finally {
            setPaying(false);
        }
    });
    // fake credit score for now
    const [creditScore, setCreditScore] = useState(0);
    useEffect(() => {
        const fakeCreditScore = getRandomNumber(300, 850);
        setCreditScore(fakeCreditScore);
    }, []);
    let earningStatus = 'locked';
    let cashoutDone = 'loading';
    if (cashoutResponse === null || cashoutResponse === void 0 ? void 0 : cashoutResponse.studentCashout) {
        cashoutDone = ((_a = cashoutResponse === null || cashoutResponse === void 0 ? void 0 : cashoutResponse.studentCashout) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'yes' : 'no';
    }
    if ((cashoutResponse === null || cashoutResponse === void 0 ? void 0 : cashoutResponse.kv) > 0) {
        earningStatus = totalEarned >= (cashoutResponse === null || cashoutResponse === void 0 ? void 0 : cashoutResponse.kv) ? (cashoutDone === 'yes' ? 'claimed' : 'cash') : 'locked';
    }
    return (React.createElement("div", { className: Styles.mainContainer },
        showCreditScore && React.createElement(CreditCardScore, { score: creditScore, close: () => setShowCreditScore(false) }),
        React.createElement("div", { style: {
                background: '#f3f3f9',
                display: 'flex',
                justifyContent: 'space-between',
                padding: '1rem 2rem',
                gridArea: 'header'
            } },
            React.createElement("h1", null, "My Wallet"),
            React.createElement("div", null,
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", rightIcon: React.createElement(IconTransferFunds, null), onClick: () => setOpenModalFunds(true) }, "Transfer Funds"))),
        React.createElement("div", { className: Styles.checking },
            React.createElement(CheckingAccountOverview, { validationTransferFunds: validationTransferFunds, showViewButton: true, manageVirtualTransactions: manageVirtualTransactions })),
        React.createElement("div", { className: Styles.creditCardSection },
            React.createElement("div", { className: Styles.header },
                React.createElement("div", { className: Styles.title }, "Credit Card"),
                React.createElement(IconButton, { className: classNames(Styles.btnLink, Styles.blue), onClick: () => navigate('/student-dashboard/my-wallet/credit-card'), disabled: true },
                    React.createElement(IconDollar, { color: "#00A3FF" }),
                    " Pay Bill"),
                React.createElement(IconButton, { className: Styles.btnLink, onClick: () => navigate('/student-dashboard/my-wallet/credit-card'), disabled: true },
                    React.createElement(IconReceiptItem, { color: "#FFA800" }),
                    " View")),
            React.createElement("div", { className: Styles.body },
                React.createElement(CreditCardComponent, { number: cardNumber, name: `${user.firstName + ' ' + user.lastName}`, expiry: `${expiry === null || expiry === void 0 ? void 0 : expiry.month}/${expiry === null || expiry === void 0 ? void 0 : expiry.year}`, limit: `${formatStringAccountBalance(creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.creditLimit)} KV` }),
                React.createElement("div", { className: Styles.summary },
                    React.createElement("div", null,
                        React.createElement("div", { className: Styles.title }, "BALANCE"),
                        React.createElement("div", { className: Styles.text }, `${formatStringAccountBalance(creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.balance)} KV`)),
                    React.createElement("div", null,
                        React.createElement("div", { className: Styles.title }, "Available Credit"),
                        React.createElement("div", { className: Styles.text }, `${formatAccountBalance(calculateAvailableCredit(creditCardAccount))} KV`)),
                    React.createElement("div", null,
                        React.createElement("div", { className: Styles.title },
                            "Credit Score",
                            React.createElement(IconButton, { onClick: () => {
                                    setShowCreditScore(true);
                                } },
                                React.createElement(MoreInfoIcon, null))),
                        React.createElement(CreditScoreText, { score: creditScore }))))),
        React.createElement("div", { className: Styles.savings },
            React.createElement(TotalSavings, { validationTransferFunds: validationTransferFunds, manageVirtualTransactions: manageVirtualTransactions, validationModalUpdateSaving: validationModalUpdateSaving, manageVirtualAccounts: manageVirtualAccounts })),
        openModalFunds && (React.createElement(TransferFundsModalWrapper, { openModal: openModalFunds, setOpenModal: setOpenModalFunds, validationTransferFunds: validationTransferFunds, manageVirtualTransactions: manageVirtualTransactions })),
        React.createElement("div", { className: Styles.lifetime }, isLoading ? (React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            } },
            React.createElement(CircleLoader, null))) : (React.createElement(LifetimeEarnings, { totalEarnings: totalEarned, status: earningStatus, onClickAction: handleOnCashout, TOTAL_EARNINGS_TO_CASHOUT: (cashoutResponse === null || cashoutResponse === void 0 ? void 0 : cashoutResponse.kv) || 0, TOTAL_USD: (cashoutResponse === null || cashoutResponse === void 0 ? void 0 : cashoutResponse.usd) || 0, paying: paying }))),
        React.createElement("div", { className: Styles.daily }, isLoading ? (React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            } },
            React.createElement(CircleLoader, null))) : (React.createElement(DailyEarnings, { dates: dates, values: [...tableValues] })))));
};
export default MyWalletOverview;
